module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-top"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-content",
    class: _vm.wide ? 'modal-content--wide' : null
  }, [(_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    class: _vm.blank ? 'body body--blank' : 'body',
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.printable) ? _c('action', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('label.print')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('action', {
    attrs: {
      "color": "green",
      "focus": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n                    OKAY\n                ")])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16eea95e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Modal.vue
// module id = 461
// module chunks = 225